import couponCodeService from '@src/utils/couponCodeService';
import { PRODUCT_COOKIES } from '@src/constants';
import useIs4ppOrEo from './useIs4ppOrEo';
import useAccountResult from './useAccountResult';

type offer = '4pp' | 'essential' | 'coupon';

export const useDiscount = () => {
  const { isE0 } = useIs4ppOrEo();
  const { hasClaimedFreeTrial, shouldShowFreeTrialLabel } = useAccountResult();
  const { getOffer } = couponCodeService();
  const currentOffer = getOffer(isE0 ? 'essential' : '4pp');
  const isPersonalisedFreeTrialOffer = [
    PRODUCT_COOKIES.PERSONALISED_PLUS.value.FREE_TRIAL,
    PRODUCT_COOKIES.PERSONALISED_PLUS.value.FB,
    PRODUCT_COOKIES.PERSONALISED_PLUS.value.GA,
    PRODUCT_COOKIES.PERSONALISED_PLUS.value.TIKTOK,
  ].includes(currentOffer || '');
  const isEssentialFreeTrialOffer = [
    PRODUCT_COOKIES.ESSENTIAL_ONE.value.FREE_TRIAL,
    PRODUCT_COOKIES.ESSENTIAL_ONE.value.REFERRAL,
    PRODUCT_COOKIES.ESSENTIAL_ONE.value.AFFILIATES,
    PRODUCT_COOKIES.ESSENTIAL_ONE.value.ESSENTIAL_ONE_20_OFF_FREE_TRIAL,
    PRODUCT_COOKIES.ESSENTIAL_ONE.value.TRIAL,
  ].includes(currentOffer || '');

  if (!currentOffer) return;
  if (hasClaimedFreeTrial) return;
  if (shouldShowFreeTrialLabel() && ((isE0 && isEssentialFreeTrialOffer) || (!isE0 && isPersonalisedFreeTrialOffer))) {
    return { text: isE0 ? '30-DAY FREE TRIAL' : '2 WEEK FREE TRIAL', color: '#51AFD5' };
  }
  if (currentOffer === PRODUCT_COOKIES.PERSONALISED_PLUS.value.FIFTY_PERCENT_OFF) {
    return { text: '50% off the first month', color: '#23A4A5' };
  }
  if (currentOffer === PRODUCT_COOKIES.PERSONALISED_PLUS.value.FIFTY_FIVE_PERCENT_OFF) {
    return { text: '55% off the first month', color: '#23A4A5' };
  }
  if (currentOffer === PRODUCT_COOKIES.PERSONALISED_PLUS.value.THIRTY_OFF_TREE_MONTH) {
    return { text: '30% off the first 3 orders', color: '#23A4A5' };
  }
  if (currentOffer === PRODUCT_COOKIES.PERSONALISED_PLUS.value.SEVENTY_OFF) {
    return { text: '70% off the first month', color: '#23A4A5' };
  }
  if (currentOffer === PRODUCT_COOKIES.PERSONALISED_PLUS.value.TWENTY_FIVE_GBP_OFF) {
    return { text: '£25 off the first month', color: '#23A4A5' };
  }
};
